import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { VersionService } from '../../services/version/version.service';

@Component({
  selector: 'atom-app-update-banner',
  templateUrl: './app-update-banner.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:visibilitychange)': 'onVisibilityChange()',
  },
})
export class AppUpdateBanner implements OnInit, OnDestroy {
  private readonly versionService = inject(VersionService);
  subscriptionList = new Subscription();
  readonly updateAvailable = signal(false);

  ngOnInit(): void {
    this.subscriptionList.add(
      this.versionService.checkVersionPeriodically().subscribe({
        next: (available) => this.setUpdateAvailable(available),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }

  onVisibilityChange(): void {
    if (document.visibilityState !== 'visible') {
      return;
    }

    this.subscriptionList.add(
      this.versionService.isUpdateAvailable().subscribe({
        next: (available) => this.setUpdateAvailable(available),
      }),
    );
  }

  reload(): void {
    globalThis.location.reload();
  }

  private setUpdateAvailable(available: boolean): void {
    if (available) {
      this.updateAvailable.set(true);
    }
  }
}
